import { Box } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useFormValidator } from "../../../../../common/inputs/useFormValidator";
import { ValidatedDateInput, ValidatedNumberInput } from "../../../../../common/inputs/ValidatedInputs";

const DateAndOccupancyEditor = (props) => {
    const { data, handleInputChange, onChangeValid } = props;
    const { checkin, checkout, adults } = data;

    // eslint-disable-next-line no-unused-vars
    const [valid, setValid, resetValid, fieldsValidity, formChanged, onFormChange] = useFormValidator();

    const onChange = useCallback((id, value, valid) => {
        const payload = {
            id,
            value,
        }

        handleInputChange([payload]) && onFormChange();
        setValid(id, valid);

    }, [handleInputChange, setValid, onFormChange])

    useEffect(() => {
        onChangeValid && onChangeValid(valid);
    }, [onChangeValid, valid]);

    const getErrorMessage = reason => {
        switch (reason) {
            case null:
            case undefined:
                return null;
            case "minDate":
                return "Check-out must be after check-in";
            case "disablePast":
                return "Selected date must be in the future";
            case "required":
                return "This field is required";
            case "invalidDate":
                return "Invalid date";
            case "min":
                return "Minimum value is not reached";
            case "max":
                return "Maximum value has been reached";
            default:
                return reason;
        }
    }

    const getLengthOfStay = () => {
        if (fieldsValidity.current['checkin'] && fieldsValidity.current['checkout']) {
            return Math.ceil((checkout - checkin) / (60 * 60 * 24 * 1000));
        }
        else return null;
    }

    const lengthOfStay = getLengthOfStay();

    return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: '10px' }}>
            <ValidatedDateInput
                id='checkin'
                label="Check-in"
                value={checkin}
                onChange={onChange}
                disablePast
                required
                getErrorMessage={getErrorMessage}
                textFieldProps={{
                    size: 'small',
                    sx: {
                        width: '220px'
                    }
                }}
                disableError={!formChanged}
            />
            <ValidatedDateInput
                id='checkout'
                label="Check-out"
                value={checkout}
                onChange={onChange}
                minDate={checkin}
                required
                getErrorMessage={getErrorMessage}
                textFieldProps={{
                    size: 'small',
                    sx: {
                        width: '220px'
                    }
                }}
                disableError={!formChanged}
                defaultCalendarMonth={checkin}
            />
            <Box sx={{ margin: '0px 0px 10px' }}>
                {lengthOfStay && `${lengthOfStay} nights`}
            </Box>
        </Box>
        <ValidatedNumberInput
            size='small'
            id="adults"
            margin="dense"
            label="Occupancy"
            min={1}
            required
            onChange={onChange}
            decimals={0}
            sx={{
                width: "120px"
            }}
            value={adults}
            getErrorMessage={getErrorMessage}
            disableError={!formChanged}
        />
    </Box>
}

export default DateAndOccupancyEditor;